import useTranslation from 'next-translate/useTranslation';
import LinkTranslated from '@/components/Translator/LinkTranslated';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import { useRouter } from 'next/router';
import useIndustryCategories from '@/lib/hooks/fetchers/useIndustryCategories';

export function IndustryCategoriesFilter() {
  const { t } = useTranslation('common');
  const { industryCategories: industryCategoriesOptions } =
    useIndustryCategories();
  const { asPath } = useRouter();
  const currentIndustryCategory = asPath.split('/').filter((e) => e !== '')[2];
  return (
    <div className='w-full items-center justify-between pt-2 text-sm text-gray-400 '>
      <Disclosure defaultOpen>
        {({ open }) => (
          <>
            <Disclosure.Button className='flex w-full items-center justify-between'>
              <h3 className='my-3 font-medium text-gray-900'>
                {t('common:Industry Categories')}
              </h3>
              <ChevronDownIcon
                className={`h-6 ${
                  open ? 'rotate-180 transform duration-200' : ''
                }`}
              />
            </Disclosure.Button>
            <Disclosure.Panel className='text-gray-500'>
              <div className='space-y-2'>
                {currentIndustryCategory && (
                  <LinkTranslated href={'/buy/'}>
                    <h3
                      className={`cursor-pointer p-2 font-light text-gray-900 transition duration-200 hover:bg-slate-300`}
                    >
                      {t('common:View All')}
                    </h3>
                  </LinkTranslated>
                )}
                {industryCategoriesOptions.map((industryCategory) => {
                  return (
                    <LinkTranslated
                      href={{
                        pathname:
                          '/buy/industry-category/[industry_category_slug]',
                        query: {
                          industry_category_slug: industryCategory.slug,
                        },
                      }}
                      key={industryCategory.id}
                    >
                      <h3
                        className={`cursor-pointer p-2 font-light text-gray-900 transition duration-200 hover:bg-slate-300 ${
                          currentIndustryCategory == industryCategory.slug
                            ? 'bg-slate-200'
                            : ''
                        }`}
                      >
                        {industryCategory.name}
                      </h3>
                    </LinkTranslated>
                  );
                })}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
